import { render } from "./CMSSinglePage.vue?vue&type=template&id=34ab3688"
import script from "./CMSSinglePage.vue?vue&type=script&lang=js"
export * from "./CMSSinglePage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__